/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StaffTargetComplianceReportModel } from '../../models/staff-target-compliance-report-model';

export interface GetStaffTargetComplianceReport$Params {
  patientID?: number;
  startTime?: string;
  endTime?: string;
  staffIDs?: Array<number>;
  programIDs?: Array<number>;
  targetIDs?: Array<number>;
  targetStatusIDs?: Array<number>;
}

export function GetStaffTargetComplianceReport(http: HttpClient, rootUrl: string, params?: GetStaffTargetComplianceReport$Params, context?: HttpContext): Observable<StrictHttpResponse<StaffTargetComplianceReportModel>> {
  const rb = new RequestBuilder(rootUrl, GetStaffTargetComplianceReport.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('staffIDs', params.staffIDs, {});
    rb.query('programIDs', params.programIDs, {});
    rb.query('targetIDs', params.targetIDs, {});
    rb.query('targetStatusIDs', params.targetStatusIDs, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StaffTargetComplianceReportModel>;
    })
  );
}

GetStaffTargetComplianceReport.PATH = '/api/Graph/GetStaffTargetComplianceReport';
